export default __webpack_public_path__ + "static/media/generic-avatar.6e39951f.png";